import { Link } from "react-router-dom";
import Button from "../../../../../components/Button";
import Title from "../../../../../components/Title";
import useAuthData from "../../../../../hook/useAppData";
import { IconClockTimer } from "../../../../../icons";

export function TitleTimeSheet() {
  const { userName } = useAuthData();
  return (
    <div className="w-auto mb-10">
      <Title title={`Time Sheet: ${userName}`}>
        <Button className="bg-primary w-auto">
          <Link to={"timesheet/form"} className="flex px-2 items-center">
            <span className="pr-3">{IconClockTimer}</span>
            <span className="font-bold">NOVO REGISTRO</span>
          </Link>
        </Button>
      </Title>
    </div>
  );
}
